module.exports = __webpack_public_path__ + "static/media/Outfit_700Bold.ad38dbc3.ttf";